import styled, { css } from "styled-components";
import Container from "../../atoms/Container/Container.styled";
import { withDisplayHeading } from "../../../themes/mixins";
import { deviceMax } from "../../../utils/device";

export const TrustFaqsSection = styled.section`
  background: ${({ theme }) => theme.colors.white};
  padding-bottom: 84px;

  @media ${deviceMax.phoneMax} {
    padding-bottom: 55px;
  }
`;

export const TrustFaqsWrapper = styled(Container)``;

export const TrustBar = styled.div(
  ({ theme }) => css`
    align-items: center;
    border-bottom: 1px solid ${theme.colors.brand.line};
    display: flex;
    gap: 30px;
    justify-content: space-between;
    margin-bottom: 80px;
    padding: 34px 0;

    @media ${deviceMax.tabletWideMax} {
      margin-bottom: 64px;
    }

    @media ${deviceMax.phoneMax} {
      display: grid;
      gap: 20px;
      grid-template-columns: 1fr;
      margin-bottom: 54px;
      padding: 28px 0;
    }
  `
);

export const TrustItem = styled.div`
  align-items: center;
  display: flex;
  font-size: 13px;
  font-weight: 600;
  gap: 13px;

  svg {
    color: ${({ theme }) => theme.colors.brand.navy};
  }

  @media ${deviceMax.tabletWideMax} {
    font-size: 11px;
    gap: 9px;
  }

  @media ${deviceMax.phoneMax} {
    font-size: 13px;
    gap: 12px;
  }
`;

export const FaqGrid = styled.div`
  display: grid;
  gap: 105px;
  grid-template-columns: 0.85fr 1.15fr;

  @media ${deviceMax.desktopSMax} {
    gap: 55px;
  }

  @media ${deviceMax.tabletWideMax} {
    gap: 40px;
    grid-template-columns: 0.8fr 1.2fr;
  }

  @media ${deviceMax.phoneMax} {
    display: block;
  }
`;

export const FaqLead = styled.div`
  @media ${deviceMax.phoneMax} {
    margin-bottom: 33px;
  }
`;

export const FaqTitle = styled.h2`
  ${withDisplayHeading()};

  @media ${deviceMax.tabletWideMax} {
    font-size: 34px;
  }

  @media ${deviceMax.phoneMax} {
    font-size: 35px;
  }
`;

export const FaqDescription = styled.p`
  color: ${({ theme }) => theme.colors.brand.muted};
  font-size: 15px;
  margin: 20px 0 22px;

  span {
    display: block;
  }

  @media ${deviceMax.phoneMax} {
    font-size: 14px;
    margin: 18px 0;
  }
`;
